export default __webpack_public_path__ + "2cc597798dfcefbfb323f52c469cda07.png";